import { ISODate } from '@frk/eds-components';
import { SimilarProductService } from '@products/similar-product/services/similar-product.service';
import { SiteConfigService } from '@services';
import { AssetClass, ConfigurationId, ProductTypeViewOption } from '@types';
import { Logger } from '@utils/logger';
import { Subject } from 'rxjs';
import { FundListingPerformanceController } from './fund-listing-performance.controller';
import { FundListingType } from './fund-listing.controller';

const logger = Logger.getLogger('SimilarProductController');

export class SimilarProductController extends FundListingPerformanceController {
  public fundListingType: FundListingType = FundListingType.SIMILAR_PRODUCT;
  constructor(
    public siteConfig: SiteConfigService,
    public readonly productType: ConfigurationId,
    public componentName: string,
    public readonly performanceAsOfDateMonthlyStd: ISODate,
    public readonly performanceAsOfDateQuarterlyStd: ISODate,
    public readonly performanceAsOfDateMonthly: string,
    public readonly performanceAsOfDateQuarterly: string,
    public readonly navAsOfDate: string,
    public readonly assetClass: AssetClass,
    public productTypeViewOptions: ProductTypeViewOption[],
    public productTypeView$: Subject<ConfigurationId>,
    public similarProductService: SimilarProductService
  ) {
    super(
      siteConfig,
      productType,
      componentName,
      performanceAsOfDateMonthlyStd,
      performanceAsOfDateQuarterlyStd,
      performanceAsOfDateMonthly,
      performanceAsOfDateQuarterly,
      navAsOfDate
    );
  }

  public setProductType = (productType: ConfigurationId): void => {
    logger.debug('setProductType()', productType);

    this.productTypeView$.next(productType);
  };
}

export const isSimilarProductController = (
  object: any
): object is SimilarProductController =>
  object.fundListingType === FundListingType.SIMILAR_PRODUCT;
